import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useAssociatedIssues } from '@atlassian/jira-portfolio-3-associated-issues/src/controllers/index.tsx';
import RoadmapAsync from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/async';
import { PlanTable } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/table';
import { connect } from '@atlassian/jira-react-redux';
import EmitLoadComplete from './emit-load-complete';
import mapStateToProps from './query';
import type { ExportProps } from './types';

// When cleaning up FF com.atlassian.rm.jpo.transposition we can remove this component entirely
const RoadmapExportWrapper = ({
	isLoading,
	onLoadComplete,
	isGoalsLoading,
	...props
}: ExportProps) => {
	const [associatedIssues] = useAssociatedIssues();

	if (ff('com.atlassian.rm.jpo.transposition')) {
		const ready =
			!isLoading &&
			!isGoalsLoading &&
			onLoadComplete !== undefined &&
			associatedIssues !== undefined;

		return (
			<>
				<PlanTable />
				{ready && <EmitLoadComplete callback={onLoadComplete} />}
			</>
		);
	}

	return <RoadmapAsync {...props} />;
};

export default connect(mapStateToProps, {})(RoadmapExportWrapper);
